import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=45e45e01&"
import script from "./order.ts?vue&type=script&lang=ts&"
export * from "./order.ts?vue&type=script&lang=ts&"
import style0 from "./Order.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports